import Vue, { ComponentOptions } from 'vue'

import ChatxModule from '@/components/chatx/chatx/chatx.module'
// eslint-disable-next-line import/extensions
import ChatAgendamento from './chat-financeiro.vue'

export default {
  components: {
    ...ChatxModule.exportComponents,
  },
  exportComponents: {
    ChatAgendamento,
  },
} as ComponentOptions<Vue> & Export

type Export = { exportComponents?: any }
